import { z } from "zod";
export const episodeReportReasonSchema = z.enum(["no_video", "wrong_episode", "audio_or_subtitles", "other"]);
export const createEpisodeReportInputSchema = z.object({
    episode: z.number().int().min(1).max(5000),
    provider: z.string().trim().min(1).max(80),
    reason: episodeReportReasonSchema,
    note: z.string().trim().max(300).optional(),
});
export const adminEpisodeReportQuerySchema = z.object({
    status: z.enum(["open", "resolved", "dismissed", "all"]).default("open"),
    page: z.coerce.number().int().positive().default(1),
    perPage: z.coerce.number().int().min(1).max(50).default(20),
});
export const resolveEpisodeReportInputSchema = z.object({ status: z.enum(["RESOLVED", "DISMISSED"]) });
//# sourceMappingURL=episode-reports.js.map